import { store } from '../../index';
import { ChatMessageAction, Sender, IMessage, ChatData,INode } from './types';
// import { chatBotBaseDataArray } from './reducers';

export const ELEMENT_ROOT = 'element-root';

export const initChatbotAction = () => {
	return {
		type: ChatMessageAction.INIT_CHATBOT
	};
};
export const fetchChatDataAction = () => {
	return {
		type: ChatMessageAction.FETCH_CHATBOT_DATA_REQUEST
	};
};

export const FetchChatbotDataSuccess = (chatbotData: ChatData) => {
	return {
		type: ChatMessageAction.FETCH_CHATBOT_DATA_SUCCESS,
		payload: {
			chatbotData: chatbotData
		}
	};
};

export const startChatbotAction = (message: string) => {
	return {
		type: ChatMessageAction.START_CHATBOT,
		payload: {
			message
		}
	};
};

export const startReactoin = () => {
	return {
		type: ChatMessageAction.START_REACTION
	};
};

export const AddMessageAction = (data: IMessage) => {
	return {
		type: ChatMessageAction.ADD_MESSAGE,
		payload: {
			id: data.message_id,
			type: data.type,
			text: data.text
		}
	};
};

export const ReplyMessageAction = (answer: INode) => {
	return {
		type: ChatMessageAction.REPLY_MESSAGE,
		payload: {
			id: answer.id,
			prev_id: answer.prev_id,
			type: Sender.OPERATOR,
			text: answer.content,
			reactionType: answer.type,
			chatImages: answer.chatImages ? answer.chatImages : null
		}
	};
};

export const InsertVisitLog = () => {
  return {
    type: ChatMessageAction.INSERT_VISIT_LOG_REQUEST
  };
};
export const InsertConversationLog = (elementId: string) => {
  return {
    type: ChatMessageAction.GET_ANSWER_REQUEST,
    payload: {
      elementId
    }
  };
};

export const getChildNodes = (id: string) => {
  const chatBotBaseDataArray = store.getState().chatBaseData;
	const parent = chatBotBaseDataArray.find((node: INode) => node.id === id);
	if (!parent) return []

  const childArray = parent.children.map((childId: string) => {
    return chatBotBaseDataArray.find((node: INode) => node.id === childId)
  })

  if (childArray.length > 0) return childArray
  return []
};

export const EndReaction = (data: IMessage) => {
	return {
		type: ChatMessageAction.END_REACTION,
		payload: {
			data
		}
	};
};

export const ReturnRootMessage = () => {
	return {
		type: ChatMessageAction.RETURN_ROOT_MESSAGE
	};
};

export const EndMessage = (message: string) => {
	return {
		type: ChatMessageAction.END_MESSAGE,
		payload: {
			message
		}
	};
};

export const ReturnRoot = (data: INode) => {
	return {
    type: ChatMessageAction.RETURN_ROOT,
		payload: {
			data
		}
	};
};

export const RetrunPrevQuestion = (data: INode) => {
	return {
		type: ChatMessageAction.RETURN_PREV_QUESTION,
		payload: {
			data
		}
	};
};

export const InputMessageAction = (message: string) => {
	return {
		type: ChatMessageAction.INPUT_CHATBOT_MESSAGE,
		payload: {
			message
		}
	};
};

export const fetchKeywordDataAction = (
  message: string,
  chatbasedata: INode[]
) => {
	return {
		type: ChatMessageAction.FETCH_KEYWORD_DATA_REQUEST,
		payload: {
			message,
      chatbasedata
		}
	};
};

export const LoadChatBotMessage = (data: IMessage[]) => {
  return {
    type: ChatMessageAction.LOAD_CHATBOT_MESSAGE,
    payload: {
      data
    }
  };
};
